var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5591 18.7998L18.0827 13.8205C17.8238 13.5853 17.4836 13.4598 17.134 13.4706C16.7843 13.4814 16.4526 13.6276 16.2087 13.8785L12.9848 17.1939C12.2088 17.0457 10.6488 16.5594 9.04288 14.9576C7.437 13.3504 6.95066 11.7863 6.8065 11.0157L10.1193 7.79046C10.3704 7.54679 10.5169 7.21496 10.5277 6.86521C10.5385 6.51546 10.4128 6.17522 10.1772 5.9165L5.19928 0.441468C4.96357 0.181938 4.63598 0.0245142 4.28607 0.00262946C3.93617 -0.0192553 3.59151 0.0961234 3.3253 0.324261L0.40185 2.83141C0.168931 3.06517 0.0299102 3.37628 0.0111576 3.70574C-0.00905065 4.04254 -0.394354 12.0207 5.79205 18.2097C11.189 23.6053 17.9493 24 19.8112 24C20.0833 24 20.2503 23.9919 20.2948 23.9892C20.6242 23.9708 20.9352 23.8311 21.1678 23.5972L23.6736 20.6724C23.9027 20.4071 24.0189 20.0627 23.9975 19.7128C23.9761 19.3629 23.8188 19.0353 23.5591 18.7998Z",
    fill: "url(#paint0_linear_2_159)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_159",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD915D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAEDC8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.30d0fe053306b743f5d5a2f7db32cf07.svg";
export { ForwardRef as ReactComponent };